import { render, staticRenderFns } from "./UnexApp.vue?vue&type=template&id=016a36c8&"
import script from "./UnexApp.vue?vue&type=script&lang=js&"
export * from "./UnexApp.vue?vue&type=script&lang=js&"
import style0 from "./UnexApp.vue?vue&type=style&index=0&id=016a36c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports